import React from 'react';
import {useSvgToElements} from './useSvgToElements';

export const NewTabMedium = (
  props: any
): React.ReactElement<React.ComponentProps<'svg'>> => {
  const svgProps = useSvgToElements({
    ...props,
    width: 12,
    height: 12,
    name: 'new-tab-medium',
  });

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...svgProps}>
      <path
        fill="currentColor"
        d="M6 1v1.3h2.78L4.54 6.54l.92.92L9.7 3.22V6H11V1H6zm1.7 8.7H2.3V4.3H4V3H2c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V8H7.7v1.7z"
      />
    </svg>
  );
};

export default NewTabMedium;
